import { render, staticRenderFns } from "./Wrapper.vue?vue&type=template&id=0cd43513&scoped=true&"
import script from "./Wrapper.vue?vue&type=script&lang=js&"
export * from "./Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./Wrapper.vue?vue&type=style&index=0&id=0cd43513&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd43513",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src469726766/src/admin-panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd43513')) {
      api.createRecord('0cd43513', component.options)
    } else {
      api.reload('0cd43513', component.options)
    }
    module.hot.accept("./Wrapper.vue?vue&type=template&id=0cd43513&scoped=true&", function () {
      api.rerender('0cd43513', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wrapper.vue"
export default component.exports